module.exports = __webpack_public_path__ + "static/media/vector-4967.b47083c4.svg";